import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import './index.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-457">
    <ThemeProvider data-id="element-458">
      <App data-id="element-459" />
    </ThemeProvider>
  </React.StrictMode>);